import React, { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { tomorrow } from "react-syntax-highlighter/dist/esm/styles/prism";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { getHeader, toastError } from "../../utils/util";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import { toast } from "react-toastify";
import JsonPrettyView from "../../widgets/JsonPrettyView";

const JsonPrettifier = () => {
  const [inputJson, setInputJson] = useState("");
  const [prettifiedJson, setPrettifiedJson] = useState("");
  const [error, setError] = useState("");

  const handlePrettify = () => {
    try {
      if (!inputJson.trim()) {
        setError("Please enter some JSON");
        return;
      }
      const parsed = JSON.parse(inputJson);
      const formatted = JSON.stringify(parsed, null, 2);
      setPrettifiedJson(formatted);
      setError("");
    } catch (err) {
      setError("Invalid JSON: " + err.message);
      setPrettifiedJson("");
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(prettifiedJson);
  };

  return (
    <Box sx={{ p: 3, maxWidth: 1200, margin: "0 auto" }}>
      <Typography variant="h4" gutterBottom>
        JSON Prettifier
      </Typography>

      <TextField
        fullWidth
        multiline
        rows={8}
        variant="outlined"
        placeholder="Paste your JSON here..."
        value={inputJson}
        onChange={(e) => setInputJson(e.target.value)}
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
        <Button
          variant="contained"
          onClick={handlePrettify}
          disabled={!inputJson.trim()}
        >
          Prettify JSON
        </Button>

        <Button
          variant="outlined"
          onClick={async () => {
            // setInputJson("");
            // setPrettifiedJson("");
            // setError("");
            try {
              await axios.post(
                `${API_ENDPOINT}/api/create-template-for-approval`,
                JSON.parse(inputJson),
                getHeader()
              );
              toast.success("success");
            } catch (error) {
              toastError(error);
            }
          }}
        >
          Clear
        </Button>
      </Box>

      {error && (
        <Typography color="error" sx={{ mb: 2 }}>
          {error}
        </Typography>
      )}

      {prettifiedJson && <JsonPrettyView prettifiedJson={prettifiedJson} />}
    </Box>
  );
};

export default JsonPrettifier;
